/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function waitForComponentInContainer(containerClass, targetClass) {
  return new Promise((resolve) => {
    const container = document.querySelector(containerClass);

    // If container doesn't exist, we cannot proceed
    if (!container) {
      console.warn(`Container ${containerClass} not found.`);
      
      return;
    }

    // Check if the component is already in the container
    const targetComponent = container.querySelector(targetClass);
    
    if (targetComponent) {
      resolve(targetComponent);
      
      return;
    }

    // Set up a MutationObserver to listen for changes in the container
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        const targetNode = Array.from(mutation.addedNodes).find(
          (node) =>
            node.nodeType === 1 &&
            node.classList.contains(targetClass.replace(".", ""))
        );

        if (targetNode) {
          observer.disconnect();
          resolve(targetNode);
          
          return;
        }
      }
    });

    // Observe only the specified container for child changes
    observer.observe(container, { childList: true, subtree: true });
  });
}

// Usage in the specified conditions
if (window.location.pathname.includes("/products/")) {
  waitForComponentInContainer(
    ".product-block-list__item--info",
    ".section-aqurate"
  ).then((component) => {
    // Once the component is loaded, move it before the target element
    const descriptionElement = document.querySelector(
      ".product-block-list__item--description"
    );
    
    if (descriptionElement && component) {
      descriptionElement.parentNode.insertBefore(component, descriptionElement);
      console.log("Component moved successfully.");
    } else {
      console.warn("Target or description element not found.");
    }
  });
}